'use client';

import classNames from 'classnames';
import { Fragment } from 'react';
import { isFilled } from '@prismicio/client';

import { Box } from '@preventx/oxygen';

// Types
import { ISOLanguageKeys } from '@/types/language';
import { SiteNavigationMenuItems } from '@/types/navigation/site';

// Components
import { Link } from '@/components/Actions/Link';
import { Dropdown } from '@/components/Site/Navigation/Standard/Dropdown';
import { DropdownPanel } from '@/components/Site/Navigation/Standard/DropdownPanel';

type NavigationAlignment = 'Default (Center)' | 'Left' | 'Right';

type SiteNavigationProps = {
  navigationTitle: string;
  language: string | ISOLanguageKeys;
  navigation: SiteNavigationMenuItems[];
  alignment: NavigationAlignment | undefined;
};

export const SiteNavigation = ({
  language,
  alignment,
  navigation,
  navigationTitle,
}: SiteNavigationProps) => (
  <Box
    component="div"
    className={classNames('nav-drawer md:hidden-below', {
      'ml-auto': alignment === 'Left',
      'mr-auto': alignment === 'Right',
    })}
  >
    <Box
      addCluster
      gap="gap-sm"
      component="nav"
      className="site-head__nav"
      aria-label={navigationTitle}
    >
      {navigation.map((menuItem) => {
        const { id, link, dropdown, panel } = menuItem;

        return (
          <Fragment key={`site-navigation-${id}`}>
            {dropdown && (
              <Dropdown
                id={dropdown.id}
                label={dropdown.label}
                options={dropdown.items}
              />
            )}

            {panel && (
              <DropdownPanel language={language} id={id} panel={panel} />
            )}

            {isFilled.link(link) && (
              <Link
                href={link}
                type="link"
                as="default"
                retainSearchParams
                className="site-head__link"
              >
                {link.text}
              </Link>
            )}
          </Fragment>
        );
      })}
    </Box>
  </Box>
);
